export default __webpack_public_path__ + "static/media/guides-icon.a2dd15e4.svg";